var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-10-08
 * @brief EHP 출동 점검 요청 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
// recoil && state
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import clog from "../../../utils/logUtils";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useNavigate } from "react-router-dom";
//
import EhpDtlPostCode from "../../common/postcode/EhpDtlPostCode";
//datepicker
import DatePicker from "react-datepicker";
import dayjs from "dayjs";
//datepicker 디자인 - 없으면 깨짐
import "react-datepicker/dist/react-datepicker.css";
//datepocker 언어
import { ko } from "date-fns/esm/locale";
/**
/**
 * @brief EHP Service - 점검출동 요청 개발 컴포넌트, 반응형 동작
 * @param param0 width:<number>: 화면(브라우저) 가로 사이즈
 * @param param1 height:<number>: 화면(브라우저) 세로 사이즈
 * @returns react components
 */
function RequestInspection(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const setParentPopWin = props.setPopWin;
    const requestCode = props.requestCode;
    //
    const [comanyTypeItem] = useState([
        { id: 0, fname: "사용자", },
        { id: 1, fname: "설치업체", },
        { id: 2, fname: "유지보수업체", },
        { id: 3, fname: "기타", },
    ]);
    //  
    const [regionItem, setRegionItem] = useState([]);
    const [maincategoryItem, setMaincategoryItem] = useState([]);
    const [middlecategoryItem, setMiddlecategoryItem] = useState([]);
    const [subcategoryItem, setSubcategoryItem] = useState([]);
    const [devicekindItem, setDevicekindItem] = useState([]);
    const [fgkindItem, setFgkindItem] = useState([]);
    const [mailReceiptSel, setMailReceiptSel] = useState("true");
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    const [addressInfo, setAddressInfo] = useState({
        "zonecode": "",
        "address": "",
        "deladdress": ""
    });
    const [errorList, setErrorList] = useState([]);
    const [maincategory, setMaincategory] = useState(null);
    const [middlecategory, setMiddlecategory] = useState(null);
    const [subcategory, setSubcategory] = useState("");
    const [devicekind, setDevicekind] = useState("");
    const [modelName, setModelName] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [content, setContent] = useState("");
    const [comanyType, setCompanyType] = useState("");
    const [region, setRegion] = useState("");
    const [fgkind, setFgkind] = useState("");
    const [buyDate, setBuyDate] = useState(null);
    const mailReceipt = (mailReceiptSel == "true") ? true : false;
    const [savedFiles, setSavedFiles] = useState([]);
    const [curPos] = useState(0);
    const [listSize] = useState(10);
    const fileRef = useRef();
    const [success, setSuccess] = useState("");
    const [middlecategoryChang, setMiddlecategoryChang] = useState(false);
    const [subcategoryChang, setSubcategoryChang] = useState(false);
    const [devicekindChang, setDevicekindChang] = useState(false);
    const errorRef = useRef(null);
    // 고객 유형
    function companyTypeSel(val) {
        setCompanyType(val.fname);
    }
    // 지역 선택 API
    function regionSel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/customerserviceapply/code/regions`,
                // appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setRegionItem(data.body);
                }
            }
        });
    }
    // 지역 선택 - select
    function regionSelect(region) {
        setRegion(region.code);
    }
    // 주소찾기 초기화
    function callbackSetSubZoneInfoAddress(val) {
        setAddressInfo(val);
    }
    useEffect(() => {
        setParentPopWin("pop-dtlpostcode", React.createElement(EhpDtlPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetSubZoneInfoAddress }));
    });
    // 주소 팝업
    function onClickPostCode(e) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_Popup(e);
    }
    // 제품 대분류  API
    function maincategorySel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/customerserviceapply/code/categories`,
                appQuery: {
                    category: "대분류",
                    // parentCode: "",
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setMaincategoryItem(data.body);
                    setMiddlecategoryChang(true);
                    setSubcategoryChang(true);
                    setDevicekindChang(true);
                }
            }
        });
    }
    // 제품 대분류 - select
    function maincategorySelect(category) {
        setErrorList(errorList.filter((err) => (err.field !== "catCode")));
        setMiddlecategoryChang(false);
        setSubcategoryChang(false);
        setDevicekindChang(false);
        setMaincategory(category);
        // document.getElementById("middelcategory").click();
    }
    // 제품 중분류  API
    function middlecategorySel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/customerserviceapply/code/categories`,
                appQuery: {
                    category: "중분류",
                    parentCode: maincategory.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setMiddlecategoryItem(data.body);
                    setSubcategoryChang(true);
                    setDevicekindChang(true);
                }
            }
        });
    }
    // 제품 중분류 - select
    function middlecategorySelect(category) {
        setErrorList(errorList.filter((err) => (err.field !== "catCode")));
        setSubcategoryChang(false);
        setDevicekindChang(false);
        setMiddlecategory(category);
    }
    // 제품 소분류  API
    function subcategorySel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/customerserviceapply/code/categories`,
                appQuery: {
                    category: "소분류",
                    parentCode: middlecategory.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setSubcategoryItem(data.body);
                }
            }
        });
    }
    // 제품 소분류 - select
    function subcategorySelect(category) {
        setErrorList(errorList.filter((err) => (err.field !== "catCode")));
        setSubcategory(category.code);
    }
    // 제품 기기 분류  API
    function devicekindSel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/customerserviceapply/code/devicekinds`,
                appQuery: {
                    // category: "소분류",
                    catMedium: middlecategory.code,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setDevicekindItem(data.body);
                }
            }
        });
    }
    // 제품 기기분류 - select
    function devicekindSelect(category) {
        setErrorList(errorList.filter((err) => (err.field !== "catCode")));
        setDevicekind(category.deviceKind);
    }
    //고장 유형 API 
    function fgkindsSel(e) {
        return __awaiter(this, void 0, void 0, function* () {
            CUTIL.onClickSelect(e, CUTIL.selectOption);
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "GET",
                appPath: `/api/v2/customerserviceapply/code/fgkinds`,
                // appQuery: {},
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setFgkindItem(data.body);
                }
            }
        });
    }
    // 고장 유형 - select
    function fgkindsSelect(fgkind) {
        setFgkind(fgkind.code);
    }
    // 모델 
    function handleSetPModelName(e) {
        setErrorList(errorList.filter((err) => (err.field !== "modelName")));
        setModelName(e.target.value);
    }
    // 시리얼
    function handleSetSeralNo(e) {
        setErrorList(errorList.filter((err) => (err.field !== "serialNo")));
        setSerialNo(e.target.value);
    }
    // 구입(설치)년월
    function handleSetBuyDate(data) {
        setErrorList(errorList.filter((err) => (err.field !== "buyDate")));
        setBuyDate(data);
    }
    //고장 내용
    function handleContent(e) {
        setErrorList(errorList.filter((err) => (err.field !== "content")));
        setContent(e.target.value);
    }
    // 첨부파일 
    function handleFileUpload(e) {
        fileRef.current.click();
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("files", file);
        var fileVal = {
            imageId: "INS_" + savedFiles.length,
            name: file.name,
            url: URL.createObjectURL(file),
            type: "INS",
            fileForm: formData,
        };
        if (savedFiles.length <= 9) {
            setSavedFiles([...savedFiles, fileVal]);
            e.target.value = ''; // file name 초기화
        }
        else {
            alert("첨부파일은 10개 까지 가능합니다.");
        }
    }
    ;
    // 이미지 삭제
    function onClickAttachFileDelete(delFile) {
        //var delFile = savedFiles[idx];
        if (!delFile.hasOwnProperty("type")) {
            URL.revokeObjectURL(delFile.url);
        }
        setSavedFiles(savedFiles.filter(file => file.imageId !== delFile.imageId));
    }
    //동의
    function handleMailReceiptSel(e) {
        setMailReceiptSel(e.target.value);
    }
    // 요청 팝업
    useEffect(() => {
        setParentPopWin("pop-small", React.createElement(RequestDoenPop, { htmlHeader: React.createElement("h1", null, (success) ? "저장" : "출동점검 요청"), success: success, requestSaved: requestSaved, requestDone: requestDone }));
    });
    // 미동의
    function disagreePop(e) {
        setParentPopWin("pop-small", React.createElement(DisagreePop, { htmlHeader: React.createElement("h1", null, "\uC5D0\uB7EC"), success: success, requestSaved: requestSaved, requestDone: requestDone }));
        CUTIL.jsopen_Popup(e);
    }
    // 요청 점검  API
    function requestSaved(e) {
        return __awaiter(this, void 0, void 0, function* () {
            var date = new Date();
            var regDate = dayjs(date).format("YYYY-MM-DDTHH:mm:ss[Z]");
            var buyData = (buyDate == null) ? null : dayjs(buyDate).format("YYYY-MM-DDTHH:mm:ss[Z]");
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/api/v2/customerserviceapply`,
                appQuery: {
                    name: userInfo.userName,
                    email: userInfo.userId,
                    hp: userInfo.phoneNumber,
                    company: userInfo.companyName,
                    companyType: comanyType,
                    zip: addressInfo.zonecode,
                    addr1: addressInfo.address,
                    addr2: addressInfo.deladdress,
                    region: region,
                    catCode: subcategory,
                    modelName: modelName,
                    serialNo: serialNo,
                    deviceKind: devicekind,
                    buyDate: buyData,
                    fgKind: fgkind,
                    content: content,
                    // filename1: ,
                    // filename2: , 
                    regDate: regDate,
                    /*       nation: ,
                          applyType: ,
                          agentCheck: ,
                          agentCompany: ,
                          agentName: ,
                          agentTel: ,
                          agentEtc: , */
                    mailReceipt: mailReceipt
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (savedFiles.length == 0) {
                        setSuccess(data.data.msg);
                    }
                    else {
                        savedFiles.map((file, idx) => {
                            if (file.hasOwnProperty("type") && (file.type == "INS")) {
                                saveFiles(data.body.customerServiceId, file.fileForm);
                            }
                        });
                        setSuccess(data.data.msg);
                    }
                }
                else {
                    setErrorList((data.errorList == null) ? [] : data.errorList);
                    var btnCommentClose = document.getElementById("pop-small");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(btnCommentClose))
                        btnCommentClose.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                    errorRef.current.focus();
                }
            }
        });
    }
    function saveFiles(customerServiceId, fileFormData) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/customerserviceapply/files?customerServiceId=${customerServiceId}`,
                appQuery: fileFormData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN CHECK ITEM LAST : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                }
            }
            //return data;
        });
    }
    function requestDone(e) {
        window.location.reload();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "box__header" },
            React.createElement("h2", null, "\uC810\uAC80\uCD9C\uB3D9 \uC694\uCCAD"),
            React.createElement("p", { className: "box__title" }, "LS ELECTRIC \uC81C\uD488\uC5D0 \uB300\uD55C \uC810\uAC80\uCD9C\uB3D9 \uC11C\uBE44\uC2A4 \uC2E0\uCCAD \uCC3D\uAD6C\uC785\uB2C8\uB2E4."),
            React.createElement("ul", { className: "box__info" },
                React.createElement("li", null, "\uC81C\uD488\uC815\uBCF4, \uAE30\uC220\uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC, \uAE30\uC220\uC0C1\uB2F4, \uAD6C\uC785\uBB38\uC758 \uB4F1\uC758 \uBB38\uC758 \uC0AC\uD56D\uC740 LS Electric \uD648\uD398\uC774\uC9C0 \uB610\uB294 1544-2080 \uAE30\uC220\uC0C1\uB2F4\uC13C\uD130\uB97C \uC774\uC6A9\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC11C\uBE44\uC2A4 \uC2E0\uCCAD \uB0B4\uC6A9\uC740 \uC811\uC218 \uD6C4, \uC810\uAC80\uCD9C\uB3D9 \uD604\uD669\uC5D0\uC11C \uD655\uC778 \uAC00\uB2A5\uD558\uBA70 \uACE0\uAC1D\uB2D8\uC5D0\uAC8C \uBA54\uC77C \uB610\uB294 \uC804\uD654\uB85C \uC5F0\uB77D \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC720,\uBB34\uC0C1\uC11C\uBE44\uC2A4\uB294 \uB2F9\uC0AC \uC11C\uBE44\uC2A4 \uCC98\uB9AC \uAE30\uC900\uC5D0 \uC758\uD558\uC5EC \uCC98\uB9AC\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC815\uC0C1\uC801\uC778 \uC0AC\uC6A9\uC0C1\uD0DC\uC5D0\uC11C \uC81C\uD488\uBCF4\uC99D\uAE30\uAC04 \uC774\uB0B4\uC5D0 \uACE0\uC7A5\uC774 \uBC1C\uC0DD\uD55C \uACBD\uC6B0\uB294 \uBB34\uC0C1 \uC11C\uBE44\uC2A4 \uC81C\uACF5\uD569\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC18C\uBE44\uC790\uC758 \uACFC\uC2E4, \uCC9C\uC7AC\uC9C0\uBCC0 \uB4F1\uC73C\uB85C \uACE0\uC7A5\uC774 \uBC1C\uC0DD\uD55C \uACBD\uC6B0\uC5D0\uB294 \uC720\uC0C1 \uC218\uB9AC(\uCD9C\uC7A5\uBE44, \uAE30\uC220\uB8CC, \uC810\uAC80\uB8CC \uC9C0\uAE09)\uB97C \uBC1B\uC544\uC57C \uD569\uB2C8\uB2E4."))),
        React.createElement("div", { className: "box__body" },
            React.createElement("div", { className: "info__input" },
                React.createElement("div", { className: "page-top" },
                    React.createElement("h3", null, "1. \uC2E0\uCCAD\uC778 \uC815\uBCF4")),
                React.createElement("div", { className: "content__info" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { readOnly: true, type: "text", value: userInfo.userName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "E-MAIL"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { readOnly: true, type: "text", value: userInfo.userId, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC5F0\uB77D\uCC98"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { readOnly: true, type: "text", value: userInfo.phoneNumber, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uACE0\uAC1D\uC5C5\uCCB4\uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { readOnly: true, type: "text", value: userInfo.companyName, disabled: true }))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uACE0\uAC1D \uC720\uD615"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "select", onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { className: "selected-value" }, "\uC120\uD0DD"),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null, (comanyTypeItem) && comanyTypeItem.map((type) => (React.createElement("li", { key: type.id, className: "option", onClick: (e) => companyTypeSel(type) }, type.fname))))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uBB38\uC758\uC9C0\uC5ED"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "select", onClick: (e) => regionSel(e) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { className: "selected-value" }, "\uC120\uD0DD"),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null, (regionItem) && regionItem.map((region, idx) => (React.createElement("li", { key: "region" + idx.toString(), className: "option", onClick: (e) => regionSelect(region) }, region.name))))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uC8FC\uC18C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("ul", { className: "input__address" },
                                    React.createElement("li", null,
                                        React.createElement("div", { className: "box__search" },
                                            React.createElement("input", { readOnly: true, type: "text", value: addressInfo.zonecode, disabled: true }),
                                            React.createElement("button", { type: "button", className: "btn btn-search", "data-pop": "pop-dtlpostcode", onClick: (e) => onClickPostCode(e) },
                                                React.createElement("span", { className: "hide" }, "\uC870\uD68C")))),
                                    React.createElement("li", null,
                                        React.createElement("input", { readOnly: true, type: "text", id: "inp2", value: addressInfo.address, disabled: true })),
                                    React.createElement("li", null,
                                        React.createElement("input", { readOnly: true, type: "text", id: "inp3", value: addressInfo.deladdress, disabled: true })))))))),
            React.createElement("div", { className: "info__input" },
                React.createElement("div", { className: "page-top" },
                    React.createElement("h3", null,
                        React.createElement("span", null, "2. \uC81C\uD488 \uACE0\uC7A5 \uB0B4\uC6A9"),
                        React.createElement("span", { className: "txt-info" },
                            React.createElement("span", { className: "txt-red mr-4" }, "*"),
                            "\uD544\uC218 \uC785\uB825 \uC0AC\uD56D"))),
                React.createElement("div", { className: "content__info" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uC81C\uD488\uBD84\uB958"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "catCode")).length > 0) && " input-error"}`, onClick: (e) => maincategorySel(e) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { className: "selected-value" }, "\uB300\uBD84\uB958"),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null, maincategoryItem.map((category, idx) => (React.createElement("li", { key: "maincategory" + idx.toString(), className: "option", onClick: (e) => maincategorySelect(category) }, category.name))))),
                                (!middlecategoryChang) ?
                                    React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "catCode")).length > 0) && " input-error"}`, onClick: (e) => (maincategory) && middlecategorySel(e) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { className: "selected-value" }, "\uC911\uBD84\uB958"),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, middlecategoryItem.map((category, idx) => (React.createElement("li", { key: "middelcategory" + idx.toString(), className: "option", onClick: (e) => middlecategorySelect(category) }, category.name)))))
                                    :
                                        React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "catCode")).length > 0) && " input-error"}`, onClick: (e) => (maincategory) && middlecategorySel(e) },
                                            React.createElement("div", { className: "selected" },
                                                React.createElement("div", { className: "selected-value" }, "\uC911\uBD84\uB958 "),
                                                React.createElement("div", { className: "arrow" })),
                                            React.createElement("ul", null, middlecategoryItem.map((category, idx) => (React.createElement("li", { key: "middelcategory" + idx.toString(), className: "option", onClick: (e) => middlecategorySelect(category) }, category.name))))),
                                (!subcategoryChang) ?
                                    React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "catCode")).length > 0) && " input-error"}`, onClick: (e) => (middlecategory) && subcategorySel(e) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { className: "selected-value" }, "\uC18C\uBD84\uB958"),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, subcategoryItem.map((category, idx) => (React.createElement("li", { key: "subcategory" + idx.toString(), className: "option", onClick: (e) => subcategorySelect(category) }, category.name)))))
                                    :
                                        React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "catCode")).length > 0) && " input-error"}`, onClick: (e) => (middlecategory) && subcategorySel(e) },
                                            React.createElement("div", { className: "selected" },
                                                React.createElement("div", { className: "selected-value" }, "\uC18C\uBD84\uB958 "),
                                                React.createElement("div", { className: "arrow" })),
                                            React.createElement("ul", null, subcategoryItem.map((category, idx) => (React.createElement("li", { key: "subcategory" + idx.toString(), className: "option", onClick: (e) => subcategorySelect(category) }, category.name))))),
                                (!devicekindChang) ?
                                    React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "catCode")).length > 0) && " input-error"}`, onClick: (e) => (middlecategory) && devicekindSel(e) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { className: "selected-value" }, "\uC120\uD0DD"),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, devicekindItem.map((devicekind, idx) => (React.createElement("li", { key: "devicekind" + idx.toString(), className: "option", onClick: (e) => devicekindSelect(devicekind) }, devicekind.deviceName)))))
                                    :
                                        React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "catCode")).length > 0) && " input-error"}`, onClick: (e) => (middlecategory) && devicekindSel(e) },
                                            React.createElement("div", { className: "selected" },
                                                React.createElement("div", { className: "selected-value" }, "\uC120\uD0DD "),
                                                React.createElement("div", { className: "arrow" })),
                                            React.createElement("ul", null, devicekindItem.map((devicekind, idx) => (React.createElement("li", { key: "devicekind" + idx.toString(), className: "option", onClick: (e) => devicekindSelect(devicekind) }, devicekind.deviceName))))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uBAA8\uB378\uBA85"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", className: ` ${(errorList.filter(err => (err.field === "modelName")).length > 0) && " input-error"}`, value: modelName, onChange: (e) => handleSetPModelName(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694." /* */ }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "modelName")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uC2DC\uB9AC\uC5BC \uBC88\uD638"),
                            React.createElement("input", { className: "hide", ref: errorRef }),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("input", { type: "text", className: ` ${(errorList.filter(err => (err.field === "serialNo")).length > 0) && " input-error"}`, value: serialNo, onChange: (e) => handleSetSeralNo(e), placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694." }),
                                React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "serialNo")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star" }, "\uAD6C\uC785(\uC124\uCE58)\uB144\uC6D4"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "searchterm" },
                                    React.createElement("div", { className: "term__date w100p" },
                                        React.createElement(DatePicker
                                        // id="dp655863510467"
                                        // className="calendar"
                                        , { 
                                            // id="dp655863510467"
                                            // className="calendar"
                                            autoComplete: "off", locale: ko, todayButton: "today", dateFormat: "yyyy-MM-dd", selected: buyDate, onChange: (date) => handleSetBuyDate(date), className: `calendar end  ${(errorList.filter(err => (err.field === "buyDate")).length > 0) && " input-error"}` }))),
                                React.createElement("p", { className: "txt-info mt-8 txt-red" }, "\uD488\uC9C8\uBCF4\uC99D\uAE30\uAC04\uC740 \u2018\uD648\uD398\uC774\uC9C0-\uC81C\uD488\uBCF4\uC99D\uAE30\uAC04\u2019\uC5D0 \uC758\uD574 \uC815\uD574\uC9C0\uBA70 \uD574\uB2F9\uAE30\uAC04 \uACBD\uACFC \uC2DC \uBE44\uC6A9\uC774 \uBC1C\uC0DD\uD560 \uC218 \uC788\uC2B5\uB2C8\uB2E4."))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uACE0\uC7A5\uC720\uD615"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "select", onClick: (e) => fgkindsSel(e) },
                                    React.createElement("div", { className: "selected" },
                                        React.createElement("div", { className: "selected-value" }, "\uC120\uD0DD"),
                                        React.createElement("div", { className: "arrow" })),
                                    React.createElement("ul", null, (fgkindItem) && fgkindItem.map((fgkind) => (React.createElement("li", { key: fgkind.code, className: "option", onClick: (e) => fgkindsSelect(fgkind) }, fgkind.name))))))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit star d-sm-none" },
                                "\uACE0\uC7A5\uB0B4\uC6A9(\uC2E4\uC81C\uC99D\uC0C1)",
                                React.createElement("br", null),
                                "\uBC0F \uC694\uCCAD\uC0AC\uD56D"),
                            React.createElement("p", { className: "tit star d-sm-block" }, "\uACE0\uC7A5\uB0B4\uC6A9(\uC2E4\uC81C\uC99D\uC0C1) \uBC0F \uC694\uCCAD\uC0AC\uD56D"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("textarea", { className: `h130 ${(errorList.filter((err) => (err.field === "content")).length > 0) && "input-error"} `, placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: content, onChange: (e) => handleContent(e) }),
                                React.createElement("p", { className: "input-errortxt top-148" }, errorList.filter(err => (err.field === "content")).map((err) => err.msg)))),
                        React.createElement("li", null,
                            React.createElement("p", { className: "tit" }, "\uCCA8\uBD80\uD30C\uC77C"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("div", { className: "filebox" },
                                    React.createElement("input", { readOnly: true, className: "upload-name", placeholder: "\uC0AC\uC9C4\uC744 \uCCA8\uBD80\uD558\uC138\uC694" }),
                                    React.createElement("label", { onClick: (e) => handleFileUpload(e) },
                                        React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uCC3E\uAE30")),
                                    React.createElement("input", { ref: fileRef, type: "file", id: "file", accept: "image/jpg, image/jpeg, image/png", onChange: (e) => saveFileImage(e) })),
                                React.createElement("ul", { className: "filelist" }, savedFiles.filter((file, idx) => (idx >= curPos) && ((idx < curPos + listSize))).map((img) => (React.createElement("li", { key: img.imageId },
                                    React.createElement("span", null, img.name),
                                    React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(img) },
                                        React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))))),
                                React.createElement("p", { className: "txt-info mt-16 mb-0" }, "* \uCCA8\uBD80\uD30C\uC77C\uC740 10\uAC1C \uC774\uD558, \uC804\uCCB4 120M\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4")))))),
            React.createElement("div", { className: "info__input" },
                React.createElement("div", { className: "page-top" },
                    React.createElement("h3", null,
                        React.createElement("span", { className: "star" }, "\uB3D9\uC758"),
                        React.createElement("span", { className: "txt-info" },
                            React.createElement("span", { className: "txt-red mr-4" }, "*"),
                            "\uD544\uC218 \uC785\uB825 \uC0AC\uD56D"))),
                React.createElement("div", { className: "content__info" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", { className: "column" },
                            React.createElement("p", { className: "tit mt-0" }, "'\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68' \uACF5\uC9C0 \uBC0F '\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68' \uC5D0 \uB3D9\uC758\uD558\uC2ED\uB2C8\uAE4C?"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("ul", { className: "terms" },
                                    React.createElement("li", { className: "mb-0" },
                                        React.createElement("div", { className: "box-scroll" },
                                            React.createElement("p", { className: "txt" },
                                                "[\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68 \uAC1C\uC694]",
                                                React.createElement("br", null),
                                                React.createElement("br", null),
                                                "LS ELECTRIC\uC740 \uC815\uBCF4\uD1B5\uC2E0\uB9DD \uC774\uC6A9\uCD09\uC9C4 \uBC0F \uC815\uBCF4\uBCF4\uD638 \uB4F1\uC5D0 \uAD00\uD55C \uBC95\uB960, \uAC1C\uC778\uC815\uBCF4\uBCF4\uD638\uBC95 \uB4F1 \uC900\uC218\uD558\uC5EC\uC57C \uD560 \uAD00\uB828 \uBC95\uADDC\uC0C1\uC758 \uAC1C\uC778\uC815\uBCF4\uBCF4\uD638\uADDC\uC815\uC744 \uC900\uC218\uD558\uBA70, \uAC1C\uC778\uC815\uBCF4\uBCF4\uD638\uBC95 \uC81C30\uC870, \uC815\uBCF4\uD1B5\uC2E0\uB9DD\uC774\uC6A9\uCD09\uC9C4 \uBC0F \uC815\uBCF4\uBCF4\uD638\uC5D0 \uAD00\uD55C \uBC95\uB960 \uC81C27\uC870\uC7582\uC5D0 \uB530\uB77C \uACE0\uAC1D\uC758 \uAC1C\uC778\uC815\uBCF4 \uBCF4\uD638 \uBC0F \uAD8C\uC775\uC744 \uBCF4\uD638\uD558\uACE0 \uAC1C\uC778\uC815\uBCF4\uC640 \uAD00\uB828\uD55C \uACE0\uAC1D\uC758 \uACE0\uCDA9\uC744 \uC6D0\uD65C\uD558\uAC8C \uCC98\uB9AC\uD560 \uC218 \uC788\uB3C4\uB85D \uB2E4\uC74C\uACFC \uAC19\uC740 \uCC98\uB9AC\uBC29\uCE68\uC744 \uC81C\uC815\uD558\uACE0 \uC774\uB97C \uC900\uC218\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.",
                                                React.createElement("br", null),
                                                React.createElement("br", null),
                                                "- LS ELECTRIC\uC740 \uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68\uC744 LS ELECTRIC \uD648\uD398\uC774\uC9C0(http://www.ls-electric.com)"))),
                                    React.createElement("li", null,
                                        React.createElement("div", { className: "input__area mt-8 txt-right" },
                                            React.createElement("div", { className: "radioBox" },
                                                React.createElement("label", { htmlFor: "rd1" },
                                                    React.createElement("input", { type: "radio", id: "rd1", name: "rd", value: "true", checked: (mailReceiptSel == "true") ? true : false, onChange: (e) => handleMailReceiptSel(e) }),
                                                    "\uB3D9\uC758"),
                                                React.createElement("label", { htmlFor: "rd2" },
                                                    React.createElement("input", { type: "radio", id: "rd2", name: "rd", value: "false", checked: (mailReceiptSel == "false") ? true : false, onChange: (e) => handleMailReceiptSel(e) }),
                                                    "\uB3D9\uC758\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."))))))),
                        React.createElement("li", { className: "mt-80" },
                            React.createElement("div", { className: "btn__wrap right w100p" }, (mailReceiptSel == "true") ?
                                React.createElement("button", { type: "button", className: " js-open", "data-pop": "pop-small", onClick: (e) => CUTIL.jsopen_Popup(e) },
                                    React.createElement("span", { "data-pop": "pop-small" }, "\uC694\uCCAD"))
                                :
                                    React.createElement("button", { type: "button", className: " js-open", "data-pop": "pop-small", onClick: (e) => disagreePop(e) },
                                        React.createElement("span", { "data-pop": "pop-small" }, "\uC694\uCCAD"))))))),
            React.createElement("ul", { className: "box__info nobg mt-90 d-sm-block" },
                React.createElement("li", null, "\uC81C\uD488\uC815\uBCF4, \uAE30\uC220\uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC, \uAE30\uC220\uC0C1\uB2F4, \uAD6C\uC785\uBB38\uC758 \uB4F1\uC758 \uBB38\uC758 \uC0AC\uD56D\uC740 LS Electric \uD648\uD398\uC774\uC9C0 \uB610\uB294 1544-2080 \uAE30\uC220\uC0C1\uB2F4\uC13C\uD130\uB97C \uC774\uC6A9\uD558\uC5EC \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC11C\uBE44\uC2A4 \uC2E0\uCCAD \uB0B4\uC6A9\uC740 \uC811\uC218 \uD6C4, \uC810\uAC80\uCD9C\uB3D9 \uD604\uD669\uC5D0\uC11C \uD655\uC778 \uAC00\uB2A5\uD558\uBA70 \uACE0\uAC1D\uB2D8\uC5D0\uAC8C \uBA54\uC77C \uB610\uB294 \uC804\uD654\uB85C \uC5F0\uB77D \uB4DC\uB9AC\uACA0\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC720,\uBB34\uC0C1\uC11C\uBE44\uC2A4\uB294 \uB2F9\uC0AC \uC11C\uBE44\uC2A4 \uCC98\uB9AC \uAE30\uC900\uC5D0 \uC758\uD558\uC5EC \uCC98\uB9AC\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC815\uC0C1\uC801\uC778 \uC0AC\uC6A9\uC0C1\uD0DC\uC5D0\uC11C \uC81C\uD488\uBCF4\uC99D\uAE30\uAC04 \uC774\uB0B4\uC5D0 \uACE0\uC7A5\uC774 \uBC1C\uC0DD\uD55C \uACBD\uC6B0\uB294 \uBB34\uC0C1 \uC11C\uBE44\uC2A4 \uC81C\uACF5\uD569\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC18C\uBE44\uC790\uC758 \uACFC\uC2E4, \uCC9C\uC7AC\uC9C0\uBCC0 \uB4F1\uC73C\uB85C \uACE0\uC7A5\uC774 \uBC1C\uC0DD\uD55C \uACBD\uC6B0\uC5D0\uB294 \uC720\uC0C1 \uC218\uB9AC(\uCD9C\uC7A5\uBE44, \uAE30\uC220\uB8CC, \uC810\uAC80\uB8CC \uC9C0\uAE09)\uB97C \uBC1B\uC544\uC57C \uD569\uB2C8\uB2E4.")))));
}
export default RequestInspection;
function RequestDoenPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const success = props.success;
    const requestSaved = props.requestSaved;
    const requestDone = props.requestDone;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, (success) ? "저장 되었습니다." : "점검출동요청을 하시겠습니까?")),
        React.createElement("div", { className: "popup__footer" },
            (!success) &&
                React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => close(e) },
                    React.createElement("span", null, "\uCDE8\uC18C")),
            (!success) ?
                React.createElement("button", { type: "button", onClick: (e) => requestSaved(e) },
                    React.createElement("span", null, "\uD655\uC778"))
                :
                    React.createElement("button", { type: "button", onClick: (e) => requestDone(e) },
                        React.createElement("span", null, "\uD655\uC778")))));
}
function DisagreePop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const success = props.success;
    const requestSaved = props.requestSaved;
    const requestDone = props.requestDone;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, "\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68\uC744 \uB3D9\uC758 \uD6C4 \uC694\uCCAD \uD558\uC138\uC694")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", onClick: (e) => close(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function close(e) {
    var btnCommentClose = document.getElementById("pop-small");
    var body = document.body;
    var dimm = body.querySelector(".dimm");
    if (!CUTIL.isnull(btnCommentClose))
        btnCommentClose.classList.add("hidden");
    if (!CUTIL.isnull(body))
        body.setAttribute("style", "overflow-y: auto;");
    if (!CUTIL.isnull(dimm))
        dimm.setAttribute("style", "display: none; z-index: 11;");
}
